module.exports = __webpack_public_path__ + "img/logos.84e0d5d0.jpg";